(function () {
	function galleryInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function () {
		galleryInit();
	});

	window.addEventListener('resize', function () {
		document.querySelectorAll('.js-media-list').forEach((root) => {
			if (root._emblaApi) {
				window.ThemeCarousel.destroy(root.querySelector('.carousel__viewport') || root);
			}
		});
		document.querySelectorAll('.js-media-sublist').forEach((root) => {
			if (root._emblaApi) {
				window.ThemeCarousel.destroy(root.querySelector('.carousel__viewport') || root);
			}
		});

		galleryInit();
	});

	galleryInit();
})();
